import { useSelector } from "react-redux";

const useCompanyInfo = () => {
  const jply_info = useSelector(state => state.partners.jply_info);
  return { jply_info };
};

export default useCompanyInfo;
